"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageBoxStyles = exports.containerStyles = void 0;
var containerStyles = {
    container: {
        border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
        borderRadius: '5px',
        backgroundColor: 'white',
        position: 'relative',
    },
    containerMobile: {
        width: '100%',
        height: 'calc(100vh - 179px)',
        backgroundColor: 'white',
    },
    topBar: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: 4,
        borderBottom: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
    },
    innerContainer: {
        padding: 4,
        height: '100%',
    },
    titlePage: {
        paddingLeft: { xs: 3, md: 0 },
    },
};
exports.containerStyles = containerStyles;
var messageBoxStyles = {
    desktop: {
        background: 'white',
        position: 'sticky',
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    mobile: {
        display: 'flex',
        alignItems: 'center',
        position: 'sticky',
        bottom: 0,
        background: '#F4F2F4',
    },
    sendButton: {
        maxWidth: '40px',
        maxHeight: '40px',
        marginRight: { sx: 0, md: 4 },
    },
};
exports.messageBoxStyles = messageBoxStyles;
